import React from "react";
export default function ActiveFilterIndicator() {
  return <div className={`w-[10px] h-[10px] rounded-full bg-red-400`} />;
}
